import { defineComponent, h } from 'vue';
import { QExpansionItem, QBtn, QDialog, QTooltip } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';
import ControlPicker from './controlPicker.jsx';

export default defineComponent({
    name: 'accordion-dsgn',
    mixins: [BaseComponentMixin],
    components: {
        QExpansionItem,
        QBtn,
        QDialog,
        QTooltip,
        ControlPicker,
    },
    data: function () {
        return {
            closeOthersEval: null,
            openedItems: [0],
        };
    },
    computed: {
        closeOthers() {
            try {
                if (this.closeOthersEval === null && this.controlData?.CloseOthers)
                    this.closeOthersEval = utils.compile(this, this.Translate(this.controlData.CloseOthers));
                if (this.closeOthersEval)
                    return utils.evaluate(this.closeOthersEval, this) == true;
                return false;
            }
            catch (e) {
                utils.warn('CloseOthers could not evaluate expression: ' + this.controlData?.CloseOthers + '; ' + e);
                return false;
            }
        },
        accordionGroups() {
            return Array.isArray(this.controlData?.AccordionGroup) ? this.controlData.AccordionGroup : [];
        },
    },
    methods: {
        onGroupModelValue(index, isOpen) {
            if (isOpen)
                this.openItem(index);
            else
                this.closeItem(index);
        },
        initializeOpenItems() {
            if (this.accordionGroups.length === 0) {
                this.openedItems = [];
                return;
            }

            const initiallyOpen = this.accordionGroups
                .map((group, index) => {
                    if (group?.IsOpen === true)
                        return index;
                    return -1;
                })
                .filter((index) => index > -1);

            this.openedItems = initiallyOpen.length > 0 ? initiallyOpen : [0];
        },
        openItem(index) {
            if (this.closeOthers)
                this.openedItems = [index];
            else if (!this.openedItems.includes(index)) {
                utils.debug(`Accordion ${this.name} openItem(index:${index})`);
                this.openedItems.push(index);
            }
        },
        closeItem(index) {
            if (this.openedItems.includes(index))
                this.openedItems = this.openedItems.filter(item => item != index);
        },
        generateItems(controls, parentType, addToName) {
            const items = [];
            if (!Array.isArray(controls))
                return items;

            for (let i = 0; i < controls.length; i++) {
                const c = controls[i];
                if (!(typeof c === 'object'))
                    continue;

                let DynamicControl = utils.getDesignerComponent(c, null);

                if (!c.$objectId) c.$objectId = utils.generateUUID();

                let id = `${c.$objectId}`;

                items.push(
                    <DynamicControl
                        key={id}
                        type={c.ControlType}
                        name={c.ControlData ? c.ControlData.Name : ''}
                        root={this.root}
                        designmodel={c}
                        parentType={parentType}
                        controlData={c.ControlData}
                        controlURL={c.ControlURL}
                        sourceIndex={i}>
                    </DynamicControl>
                );
            }

            if (this.selected$)
                items.push(
                    <QBtn key="addctl" size="sm" flat icon="mdi-plus-circle" color="blue-8" style={{ zIndex: 992 }} onClick={(e) => this.addControl(e, controls)}>
                        <QTooltip>Add control to {addToName}</QTooltip>
                    </QBtn>
                );

            return items;
        },
        renderGroup(groupData, index) {
            //return <div>Group {index}</div>;

            const groupTitle = groupData.GroupTitle;
            const titleContent = [];

            if (groupData?.PreTitleControls?.length)
                titleContent.push(
                    <div class="c-StackContent-header row items-center no-wrap q-mr-sm">
                        {this.generateItems(groupData.PreTitleControls, 'HorizontalLayout', 'pre-title controls')}
                    </div>);

            if (groupTitle)
                titleContent.push(<div class="q-mr-sm">{groupTitle}</div>);

            if (groupData?.HeaderControls?.length)
                titleContent.push(
                    <div class="c-StackContent-header row items-center no-wrap q-mr-sm">
                        {this.generateItems(groupData.HeaderControls, 'HorizontalLayout', 'header')}
                    </div>);

            const body = this.generateItems(groupData?.AccordionBody, 'VerticalLayout', 'body');

            const slots = {
                header: () => (
                    <div class="row items-center no-wrap full-width">
                        {titleContent}
                    </div>
                ),
                default: () => (
                    <div class="column" style="align-items: flex-start;">
                        {body}
                    </div>
                )
            };

            return (
                <QExpansionItem
                    key={index + '_' + (groupData?.$objectId || groupData?.$objectid || 'group')}
                    modelValue={this.openedItems.includes(index)}
                    onUpdate:modelValue={(isOpen) => this.onGroupModelValue(index, isOpen)}
                    expandIcon="keyboard_arrow_down"
                    class="c-AccordionGroup"
                >
                    {slots}
                </QExpansionItem>
            );
        },
    },
    props: {
    },
    created() {
        this.initializeOpenItems();
    },
    render() {
        const style = {
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid #ddd',
            margin: '3px',
            borderRadius: '8px',
            ...utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent),
        };

        try {
            let body = this.accordionGroups.map((groupItem, index) => this.renderGroup(groupItem, index));
            //let body = <div>Accordion Body</div>;

            return (
                <div
                    class={{ 'designer-container': true, selected: this.selected$ }}
                    style={style}
                    onClick={(e) => this.handleClick(e)}
                >
                    <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }}></div>
                    {body}

                    {this.generatePicker(h)}
                </div>
            );
        }
        catch (e) {
            utils.error('Accordion Render failed', e);
            return <div>Accordion Failed to Render {String(e)}</div>;
        }
    }
});
